export default function Chat(props) {
    return (
        <div className={'flex flex-col rounded-full w-7 h-4 p-0.5 shadow-inner transition ' + (props.checked ? 'bg-white/100' : 'bg-white/50') + ' ' + (props.className || '')}>

            <div className={'h-full aspect-square rounded-full shadow transition ' + (props.checked ? 'bg-secondary self-end' : 'bg-white self-start')} />

        </div>
    );
}
